import React, { useState } from 'react';
import { OnboardingData, OnboardingTrack } from '../../types/onboarding';

interface Props {
    onNext: (data: Partial<OnboardingData>) => void;
    initialData: Partial<OnboardingData>;
    isTransitioning?: boolean;
}

const OnboardingTrackStep: React.FC<Props> = ({ onNext, initialData, isTransitioning }) => {
    const [selectedTrack, setSelectedTrack] = useState<OnboardingTrack | undefined>(undefined);

    const handleSelect = (track: OnboardingTrack) => {
        setSelectedTrack(track);
        // Delay to show selected state
        setTimeout(() => {
            // Default timeframe to 'unsure' as we ask for specific date later
            onNext({ track, timeframe: 'unsure' });
        }, 350);
    };

    const Option: React.FC<{
        label: string,
        trackValue: OnboardingTrack,
        currentValue: OnboardingTrack | undefined
    }> = ({ label, trackValue, currentValue }) => (
        <button
            onClick={() => handleSelect(trackValue)}
            disabled={isTransitioning}
            className={`w-full px-6 py-3.5 rounded-xl border-2 border-b-[6px] transition-all duration-200 text-base font-bold ${trackValue === currentValue
                ? 'border-brand-orange bg-[#fed7aa] text-brand-orange shadow-sm translate-y-[2px]'
                : 'border-gray-300 dark:border-gray-600 hover:border-brand-orange/50 hover:bg-gray-50 dark:hover:bg-gray-800 text-gray-700 dark:text-gray-200'
                } active:border-b-2 active:translate-y-[6px] disabled:opacity-50 disabled:cursor-not-allowed`}
        >
            {label}
        </button>
    );

    return (
        <div className="space-y-12 animate-in fade-in slide-in-from-right-4 duration-300">
            {/* Q1 */}
            <div>
                <label className="block text-gray-900 dark:text-white font-bold text-2xl mb-2">Na co se připravuješ?</label>
                <p className="text-gray-500 dark:text-gray-400 text-sm mb-8">
                    Vyber si, na kterou část SCIO testů se chceš zaměřit
                </p>
                <div className="flex flex-col gap-3 max-w-md mx-auto">
                    <Option label="OSP (SCIO OSP)" trackValue="OSP" currentValue={selectedTrack} />
                    <Option label="ZSV (SCIO ZSV)" trackValue="ZSV" currentValue={selectedTrack} />
                    <Option label="Obojí" trackValue="BOTH" currentValue={selectedTrack} />
                    <Option label="Nevím" trackValue="BOTH" currentValue={selectedTrack} />
                </div>
            </div>
        </div>
    );
};

export default OnboardingTrackStep;
